import { IconCaution } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { memo } from 'react';
import styles from '../TransactionDetailSection.module.scss';

const cx = classnames.bind(styles);

interface WarningMessageProps {
  message?: string;
}

export const WarningMessage = memo(({ message }: WarningMessageProps) => {
  if (!message) {
    return null;
  }

  return (
    <div className={cx('cautionContainer')}>
      <IconCaution height={12} width={12} />
      {message}
    </div>
  );
});

WarningMessage.displayName = 'WarningMessage';
